import PropTypes from 'prop-types';
import TemplateIndicator from './template-indicator';
import ThankviewIndicator from './thankview-indicator';
import CadenceIndicator from './cadence-indicator';
import ThreadIndicator from './thread-indicator';
import AttachmentIndicator from './attachment-indicator';
import { isEmpty } from '@evertrue/sdk';

const IndicatorGroup = ({ threadCount, emailTemplate, thankviewVideos, attachments, journeyResponse }) => {
  return (
    <div className="outreach-card-tab-group">
      {threadCount > 1 && <ThreadIndicator threadCount={threadCount} />}

      {!isEmpty(emailTemplate) && <TemplateIndicator emailTemplate={emailTemplate} />}

      {attachments.length > 0 &&
        attachments.map((attachment, index) => (
          <AttachmentIndicator key={attachment.content_id || index} attachment={attachment} />
        ))}

      {journeyResponse && <CadenceIndicator journeyResponse={journeyResponse} />}

      {thankviewVideos.length > 0 && <ThankviewIndicator thankviewVideos={thankviewVideos} />}
    </div>
  );
};

IndicatorGroup.propTypes = {
  threadCount: PropTypes.number,
  emailTemplate: PropTypes.object,
  thankviewVideos: PropTypes.array,
  attachments: PropTypes.array,
  journeyResponse: PropTypes.object,
};

export default IndicatorGroup;
